import { NativeModules } from 'react-native';
export const { SystemCaptionsModule } = NativeModules;
